import React from 'react'
import {
  Card,
  Form,
  Button,
  Input,
  Select,
  DatePicker,
  Upload,
  message,
  Cascader, Divider, Row, Col, Modal, Space,
} from 'antd'
import './index.less'
import PlusCircleOutlined from "@ant-design/icons/lib/icons/PlusCircleOutlined";
import MinusCircleOutlined from "@ant-design/icons/lib/icons/MinusCircleOutlined";
import TextArea from "antd/lib/input/TextArea";
import {API_IMG_UPLOAD} from "../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import ImgCrop from "antd-img-crop";
import {NavLink, withRouter} from "react-router-dom";
import {getCategorieList, getMaterialList, getProductSave} from "../../../constants/api";
import {removeToken} from "../../../utils/cookie";

import {COMMON_ROUTER} from "../../../constants";

const FormItem = Form.Item;

/**
 * @Description: 封装FormList
 * @Author Jiang
 * @Date 2020/7/29 9:36
 */
const MyFormList = ({form, initialValue, ...props}) => {
  React.useEffect(() => {
    form.setFields([
      {
        name: props.name,
        value: initialValue
      }
    ]);
  }, []);

  return <Form.List {...props} />;
};
const form = Form.useForm;

class AddGood extends React.Component {


  state = {
    templateId: '',
    shopId: '',
    listSepecification: [{key: "0"}], //添加规格框的数量
    listAttribute: [{key: "0"}], //添加规格框的数量
    listMaterial: [{key: "0"}], //添加原料框的数量
    listSaleTime: [{key: "0"}], // 售卖时间段自定义时间
    saleTime: '',//售卖时间
    isSaleHot: '', //是否热销
    isSingle: '', //是否单点
    isFull: '', //是否次日置满
    timeInterval: '', //
    goodsClassify: '',// 商品分类
    previewVisible: false,
    previewImage: '',
    fileList: [],
    platformType: '' //平台类型
  }

  componentWillMount() {
    this.setState({
      templateId: this.props.location.state.templateId,
      shopId: this.props.location.state.shopId,
      platformType: this.props.location.state.platformType
    })


  }


  componentDidMount() {
    this.getGoodsClassify();
    this.getGoodsMaterial()
  }

  /**
   * @Description 获取商品分类
   * @Author Jiang
   * @Date 2020/7/26 11:34
   */
  getGoodsClassify = () => {
    getCategorieList({
      pageIndex: 0,
      pageSize: 100,
      sortName: "",
      sortType: "",
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let classify = data.data.records;
          this.setState({
            goodsClassify: classify
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axios.post(API_GOODS_CLASSIFY, {
    //   pageIndex: 0,
    //   pageSize: 100,
    //   sortName: "",
    //   sortType: "descending",
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let classify = data.data.records;
    //       this.setState({
    //         goodsClassify: classify
    //       })
    //     }
    //   }
    // })
  }

  /**
   * @Description: 获取商品原料
   * @Author Jiang
   * @Date 2020/7/26 11:55
   */
  getGoodsMaterial = (parentId = 0, targetOption = []) => {
    getMaterialList({
      parentId: parentId,
      platformType: this.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let material = data.data
          if (parentId === 0) {
            material.map((item, index) => {
              item['isLeaf'] = false
            })
            this.setState({
              material: material
            })
          }
          if (parentId !== 0 && targetOption.lev === 1) {
            material.map((item, index) => {
              item['isLeaf'] = false
            })
            targetOption.children = material
            this.setState({
              material: [...this.state.material]
            })
          }
          if (parentId !== 0 && targetOption.lev === 2) {
            material.map((item, index) => {
              item['isLeaf'] = true
            })
            targetOption.children = material
            this.setState({
              material: [...this.state.material]
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_MATERIAl, {
    //   parentId: parentId,
    //   platformType: this.state.platformType
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let material = data.data
    //       if (parentId === 0) {
    //         material.map((item, index) => {
    //           item['isLeaf'] = false
    //         })
    //         this.setState({
    //           material: material
    //         })
    //       }
    //       if (parentId !== 0 && targetOption.lev === 1) {
    //         material.map((item, index) => {
    //           item['isLeaf'] = false
    //         })
    //         targetOption.children = material
    //         this.setState({
    //           material: [...this.state.material]
    //         })
    //       }
    //       if (parentId !== 0 && targetOption.lev === 2) {
    //         material.map((item, index) => {
    //           item['isLeaf'] = true
    //         })
    //         targetOption.children = material
    //         this.setState({
    //           material: [...this.state.material]
    //         })
    //       }
    //     }
    //   }
    // })
  }

  /**
   * @Description: 动态加载原料
   * @Author Jiang
   * @Date 2020/7/26 14:06
   */
  onMaterialChange = (value, selectedOptions) => {

  }


  //base64图片文件
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  //图片预览取消函数
  handleCancel = () => this.setState({previewVisible: false});

  //图片预览弹窗函数
  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };
  beforeUpload = (file) => {
    //限制图片 格式、size、分辨率
    const isJPG = file.type === 'image/jpeg';
    const isJPEG = file.type === 'image/jpeg';
    const isGIF = file.type === 'image/gif';
    const isPNG = file.type === 'image/png';
    if (!(isJPG || isJPEG || isGIF || isPNG)) {
      Modal.error({
        title: '只能上传JPG 、JPEG 、GIF、 PNG格式的图片~',
      });
      return;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      Modal.error({
        title: '超过5M限制，不允许上传~',
      });
      return;
    }
    return (isJPG || isJPEG || isGIF || isPNG) && isLt2M && this.checkImageWH(file);
  }

  //返回一个 promise：检测通过则返回resolve；失败则返回reject，并阻止图片上传
  checkImageWH(file) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let filereader = new FileReader();
      filereader.onload = e => {
        let src = e.target.result;
        const image = new Image();
        image.onload = function () {
          // 获取图片的宽高，并存放到file对象中
          file.width = this.width;
          file.height = this.height;
          resolve();
        };
        image.onerror = reject;
        image.src = src;
      };
      filereader.readAsDataURL(file);
    });
  }

  //上传文件改变时的状态，详情可以参考antd的Upload组件API参数
  onImgChange = ({fileList, file, event}) => {
    this.setState({
      fileList: fileList,
    });

  };


  /**
   * @Description: 动态获取原料子级数据
   * @Author Jiang
   * @Date 2020/7/26 14:08
   */
  loadData = selectedOptions => {
    //得到所选的select
    const targetOption = selectedOptions[selectedOptions.length - 1];
    this.getGoodsMaterial(targetOption.id, targetOption)

  };


  /**
   * @Description: 显示更多
   * @Author Jiang
   * @Date 2020/7/26 17:04
   */
  showMore = () => {

  }

  onChangeTimeinterval = e => {
    this.setState({
      timeInterval: e.target.value,
    });
  };

  onChangeWeek(checkedValues) {

  }


  onChange = e => {
    this.setState({
      saleTime: e.target.value,
    });
  };
  onChangeHot = (e) => {
    this.setState({
      isSaleHot: e.target.value,
    });
  }
  onChangeSingle = (e) => {
    this.setState({
      isSingle: e.target.value,
    });
  }

  onChangeFull = (e) => {
    this.setState({
        isFull: e.target.value
      }
    )
  }
  /*提交数据*/
  onFinish = (values) => {
    //处理规格
    let specList = values.specification
    specList.map((spec, index) => {
      spec['activityLevel'] = 0
      spec['barCode'] = ""
      spec['onShelf'] = 1
      spec['pid'] = 0
      spec['specId'] = 0
      spec['stockStatus'] = 0
      spec['weight'] = 0
    })
    //处理原料
    let materialList = values.materialList

    let materialListTemp = [];
    materialList && materialList.map((material, index) => {
      let m = material.material;
      let end = m[m.length - 1];
      let obj = {id: end};
      materialListTemp.push(obj)
    })
    //商品描述
    let description = values.description
    //商品名称
    let productName = values.productName
    //店铺Id
    let shopId = 0
    //商品最小购买量
    let minPurchaseQuantity = values.minPurchaseQuantity
    //商品单位
    let unit = values.unit
    //商品分类
    let xmCategoryId = values.xmCategoryId
    //商品图片
    let fileList = this.state.fileList
    let file = fileList[0];
    let res = file.response;
    if (res.code === 0) {
      let img = res.data
      var imageHash = img.imageHash
      var imageUrl = img.imageUrl
    }
    //商品标签
    let labels = values.labels;
    let isFeatured = 0;
    let isGum = 0;
    let isNew = 0;
    let isSpicy = 0;
    labels && labels.map((label, index) => {
      switch (label) {
        case "0":
          isFeatured = 1
          break;
        case "1":
          isNew = 1;
          break;
        case "2":
          isSpicy = 1;
          break;
        default:
          break
      }
    })
    labels = {};
    labels['isFeatured'] = isFeatured;
    labels['isNew'] = isNew;
    labels['isSpicy'] = isSpicy;
    labels['isGum'] = isGum;
    //模板
    let templateId = 2;

    //售卖属性
    let attribute = values.attribute;


    let attributeTemp = []
    attribute && attribute.map((item, index) => {
      let details = [];
      let attributeName = item.attributeName;
      if (item.detail_one) {
        details.push(item.detail_one)
      }
      if (item.detail_two) {
        details.push(item.detail_two)
      }
      if (item.detail_three) {
        details.push(item.detail_three)
      }
      if (item.detail_four) {
        details.push(item.detail_four)
      }

      let attr = {};
      attr['attributeName'] = attributeName;
      attr['details'] = details
      attributeTemp.push(attr)
    })

    getProductSave({
      description: description,
      imageHash: imageHash,
      imageUrl: imageUrl,
      labels: labels,
      attribute: attributeTemp,
      materialList: materialListTemp,
      minPurchaseQuantity: minPurchaseQuantity,
      productName: productName,
      shopId: this.state.shopId,
      specList: specList,
      templateId: this.state.templateId,
      unit: unit,
      xmCategoryId: xmCategoryId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success('创建成功', 1, () => {
            this.props.history.push(COMMON_ROUTER + '/goods')
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_SAVE, {
    //   description: description,
    //   imageHash: imageHash,
    //   imageUrl: imageUrl,
    //   labels: labels,
    //   attribute: attributeTemp,
    //   materialList: materialListTemp,
    //   minPurchaseQuantity: minPurchaseQuantity,
    //   productName: productName,
    //   shopId: this.state.shopId,
    //   specList: specList,
    //   templateId: this.state.templateId,
    //   unit: unit,
    //   xmCategoryId: xmCategoryId
    // }).then((response) => {
    //   let data = response.data;
    //   if (data.code === 0) {
    //     message.success('创建成功', 1, () => {
    //       this.props.history.push(COMMON_ROUTER + '/goods')
    //     })
    //   } else {
    //     message.error(data.msg)
    //   }
    // }).catch(function (error) {
    //   console.log(error);
    // });
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: 24,
        sm: 4
      },
      wrapperCol: {
        xs: 24,
        sm: 12
      }
    }
    const offsetLayout = {
      wrapperCol: {
        xs: 24,
        sm: {
          span: 12,
          offset: 4
        }
      }
    }

    let featureData = [
      {
        title: '招牌菜',
        value: '0',
      },
      {
        title: '新菜',
        value: '1',
      },
      {
        title: '辣',
        value: '2',
      },
    ];

    const {RangePicker} = DatePicker;
    const format = 'HH:mm';
    const dateOptions = ['周一', '周二', '周三', '周四', '周四', '周五', '周六', '周日'];
    let {listSepecification, material, listAttribute, listMaterial, listSaleTime, goodsClassify, previewVisible, previewImage, fileList} = this.state

    //根据官方属性定制化裁剪框大小固定的裁剪组件属性
    const props = {
      width: 800,  //裁剪宽度
      height: 800, //裁剪高度
      resize: false, //裁剪是否可以调整大小
      resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
      modalTitle: "上传图片", //弹窗标题
      modalWidth: 900, //弹窗宽度
    };
    let fetchedFields1 = [{'name': 0, 'key': 0, 'fieldKey': 0}, {'name': 1, 'key': 1, 'fieldKey': 1}];
    let fetchedFields2 = [{'name': 0, 'key': 0, 'fieldKey': 0}];
    return (
      <Card style={{width: "100%", overflowY: "auto", height: "100vh", padding: "0 0 40px"}} title="新建商品">
        <Form initialValues={{specification: fetchedFields2, attribute: fetchedFields1, materialList: fetchedFields2}}
              onFinish={this.onFinish.bind(this)}>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
            <Col className={['gutter-row']} offset={6} span={2}>
              <div className='input-title'>基本信息</div>
            </Col>
            <Col className='gutter-row' id='xmCategoryId' span={10}>
              {goodsClassify &&
              <FormItem name='xmCategoryId' rules={[
                {
                  required: true,
                  message: '商品分类不能为空'
                }
              ]} label="商品分类" {...formItemLayout}>
                <Select style={{marginLeft: "20px"}}
                        getPopupContainer={() => document.getElementById('xmCategoryId')}>
                  {goodsClassify && goodsClassify.map((classify, iindex) => {
                    return <Select.Option key={classify.categorieId}
                                          value={classify.categorieId}>{classify.categorieName}</Select.Option>
                  })}
                </Select>
              </FormItem>
              }
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='productName' label="商品名称"
                        rules={[{required: true, message: '请输入商品名称',}]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品名称"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='description' label="商品描述" {...formItemLayout}>
                <TextArea style={{marginLeft: "20px"}} placeholder={'请输入商品描述'} rows={4}/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem label="商品图片" labelCol={{span: 4}}
                        {...formItemLayout}>
                {/*<ImgCrop {...props}>*/}
                  <Upload
                    name="file"
                    action={API_IMG_UPLOAD}
                    data={{platformType: this.state.platformType}}
                    accept="image/*"
                    listType="picture"
                    fileList={fileList}
                    beforeUpload={this.beforeUpload.bind(this)}
                    onPreview={this.handlePreview}
                    onChange={this.onImgChange}
                  >
                    {fileList.length >= 1 ? null : (<div className='img-container'>
                      <div>
                        <PlusOutlined style={{fontSize: "20px"}}/>
                        点击上传
                      </div>
                    </div>)}
                    {/* {通过三木运算符判断文件列表fileList的长度来决定上传图片的数量，达到控制图片数量的功能} */}
                  </Upload>
                {/*</ImgCrop>*/}
                {/* {图片预览弹出框：可以实时查看上传的图片} */}
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} title='Image-Show'>
                  <img alt="example" style={{width: '100%'}} src={previewImage}/>
                </Modal>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='minPurchaseQuantity' label="最小购买量" rules={[{required: true}]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入最小购买数量"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='unit' rules={[
                {
                  required: true,
                  message: '只能输入中英文，最多2个字',
                }
              ]} label="商品单位" {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品单位"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
            <Col className='gutter-row' id='labels' offset={8} span={10}>
              {featureData &&
              <FormItem name='labels' label="商品特色" {...formItemLayout}>
                <Select mode='tags' placeholder={'请选择标签，最多可选择3个'} style={{marginLeft: "20px"}}
                        getPopupContainer={() => document.getElementById('labels')}>
                  {featureData && featureData.map((feature, iindex) => {
                    return <Select.Option key={feature.value}
                                          value={feature.value}>{feature.title}</Select.Option>
                  })}
                </Select>
              </FormItem>
              }
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={2} span={20}>
              <Divider/>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="top">
            <Col className={['gutter-row',]} offset={6} span={2}>
              <div className='input-title'>售卖规格</div>
            </Col>
            <Col className='gutter-row' span={12}>
              <Form.List name="specification">
                {(fields, {add, remove}) => {
                  return (
                    <div>
                      {fields.map(field => (
                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}} align="start">
                          <FormItem
                            name={[field.name, 'specName']}
                            rules={[
                              {
                                required: true,
                                message: '只能输入中英文，最多2个字',
                              }
                            ]} label="规格名" layout="vercital">
                            <Input className='input-size'/>
                          </FormItem>
                          <FormItem
                            name={[field.name, 'price']}
                            rules={[
                              {
                                required: true,
                                message: '只能输入中英文，最多2个字',
                              }
                            ]} label="价格" layout="vercital">
                            <Input className='input-size'
                                   addonAfter="元"/>
                          </FormItem>
                          <FormItem name={[field.name, 'packingFee']} rules={[
                            {
                              required: true,
                              message: '只能输入中英文，最多2个字',
                            }
                          ]} label="餐盒费" layout="vercital">

                            <Input className='input-size'
                                   addonAfter="元"/>
                          </FormItem>
                          <Form.Item label={'当前库存/最大库存'} rules={[{required: true}]} layout="vercital">
                            <Input.Group className='inventory'>
                              <Form.Item style={{
                                width: '70px',
                                border: 0,
                                padding: 0,
                                textAlign: 'center'
                              }} name={[field.name, 'stock']} layout="vercital">
                                <Input style={{
                                  border: 0, height: '24px',
                                  lineHeight: "24px",
                                }} placeholder="10000"/>
                              </Form.Item>
                              <div className='incline'>
                                /
                              </div>
                              <Form.Item className="site-input-right"
                                         style={{
                                           width: '70px',
                                           textAlign: 'center',
                                           border: 0
                                         }}
                                         name={[field.name, 'maxStock']}
                              >
                                <Input
                                  style={{
                                    boxShadow: 'none',
                                    border: 0, height: '24px',
                                    lineHeight: "24px",
                                  }}
                                  placeholder="10000"
                                />
                              </Form.Item>
                            </Input.Group>
                          </Form.Item>
                          {/*  <FormItem className='full'>
                            <div style={{display: "flex", flexDirection: "row"}}>
                              <Form.Item name={[field.name, 'full']}>
                                <Checkbox checked={false} onChange={this.onChangeFull.bind(this)}>次日置满</Checkbox>
                              </Form.Item>
                              <InfoCircleFilled style={{color: '#535353'}}/>
                              <div className='more'>
                                <a onClick={this.showMore.bind(this)}>更多</a>
                              </div>
                            </div>
                          </FormItem>*/}

                          {fields.length > 1 ? (
                            <MinusCircleOutlined
                              className="dynamic-delete-button"
                              style={{margin: '0 8px'}}
                              onClick={() => {
                                remove(field.name);
                              }}
                            />
                          ) : null}
                        </Space>
                      ))}

                      <Form.Item>
                        <a
                          type="dashed"
                          onClick={() => {
                            add();
                          }}
                        >
                          <PlusCircleOutlined/> 添加规格最多10个
                        </a>
                      </Form.Item>
                    </div>
                  );
                }}
              </Form.List>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
            <Col className={['gutter-row',]} offset={6} span={2}>
              <div className='input-title'>售卖属性</div>
            </Col>
            <Col className='gutter-row' id='materialList' span={10}>
              <Form.List name="attribute">
                {(fields, {add, remove}) => {
                  return (
                    <div>
                      {fields.map((field, index) => (
                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}}>
                          <div key={index.toString()}>
                            <div>
                              同种价格多种口味，如：少糖、半糖等 &nbsp;&nbsp;
                              <a>了解详情</a>
                            </div>
                            <div className='input-specification'>
                              <FormItem
                                name={[field.name, 'attributeName']} label="属性名称" layout="vercital">
                                <Input className='input-size' placeholder='如:辣度'/>
                              </FormItem>
                              <FormItem rules={[
                                {
                                  required: true,
                                }
                              ]} label="属性细分(至少填2个)" layout="vercital">
                                <Input.Group compact>
                                  <FormItem name={[field.name, 'detail_one']} wrapperCol={{span: 12}} layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_two']} wrapperCol={{span: 12}} layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_three']} wrapperCol={{span: 12}}
                                            layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_four']} wrapperCol={{span: 12}}
                                            layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                </Input.Group>
                              </FormItem>
                            </div>
                          </div>
                          {fields.length > 0 ? (
                            <MinusCircleOutlined
                              className="dynamic-delete-button"
                              style={{margin: '0 8px'}}
                              onClick={() => {
                                remove(field.name);
                              }}
                            />
                          ) : null}

                        </Space>
                      ))}

                      <Form.Item>
                        <a
                          type="dashed"
                          onClick={() => {
                            add();
                          }}
                        >
                          <PlusCircleOutlined/> 添加属性最多5个
                        </a>
                      </Form.Item>
                    </div>
                  );
                }}
              </Form.List>
            </Col>


          </Row>

          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
            <Col className={['gutter-row',]} offset={6} span={2}>
              <div className='input-title'>商品原料</div>
            </Col>
            <Col className='gutter-row' id='materialList' span={12}>
              <Form.List name="materialList">
                {(fields, {add, remove}) => {
                  return (
                    <div>
                      {fields.map((field, index) => (
                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}} align="start">
                          <FormItem name={[field.name, 'material']} rules={[
                            {
                              required: true,
                              message: '商品名称不能为空'
                            }
                          ]}>
                            <Cascader
                              allowClear
                              fieldNames={{label: 'materialName', value: 'id',}}
                              options={material}
                              loadData={this.loadData.bind(this)}
                              onChange={this.onMaterialChange.bind(this)}
                              changeOnSelect
                              getPopupContainer={() => document.getElementById('materialList')}
                              placeholder={'请选择'}
                            />
                          </FormItem>
                          {fields.length > 1 ? (
                            <MinusCircleOutlined
                              className="dynamic-delete-button"
                              style={{margin: '0 8px'}}
                              onClick={() => {
                                remove(field.name);
                              }}
                            />
                          ) : null}

                        </Space>
                      ))}

                      <Form.Item>
                        <a
                          type="dashed"
                          onClick={() => {
                            add();
                          }}
                        >
                          <PlusCircleOutlined/> 添加原料最多5个
                        </a>
                      </Form.Item>
                    </div>
                  );
                }}
              </Form.List>
            </Col>
          </Row>
          {/*********售卖时间***********/}
          {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="center" align="center">*/}
          {/*  <Col className={['gutter-row',]} offset={6} span={2}>*/}
          {/*    <div className='input-title-size'>售卖时间</div>*/}
          {/*  </Col>*/}
          {/*  <Col className='gutter-row' span={12}>*/}
          {/*    <Form.Item label="售卖时间段">*/}
          {/*      <RadioGroup onChange={this.onChange.bind(this)} value={this.state.saleTime}>*/}
          {/*        <Radio value={1}>全时段售卖</Radio>*/}
          {/*        <Radio value={2}>自定义时间</Radio>*/}
          {/*      </RadioGroup>*/}
          {/*    </Form.Item>*/}
          {/*    {*/}
          {/*      this.state.saleTime == 2 ?*/}
          {/*        <div>*/}
          {/*          <FormItem label='选择时间段'>*/}
          {/*            <RangePicker style={{marginLeft: "10px"}}/>*/}
          {/*            <Checkbox.Group options={dateOptions}*/}
          {/*                            defaultValue={['周一', '周二', '周三', '周四', '周四', '周五', '周六', '周日']}*/}
          {/*                            onChange={this.onChangeWeek.bind(this)}/>*/}
          {/*          </FormItem>*/}
          {/*          <FormItem label='售卖时间段'>*/}
          {/*            <RadioGroup style={{marginLeft: "10px"}}*/}
          {/*                        onChange={this.onChangeTimeinterval.bind(this)}*/}
          {/*                        value={this.state.timeInterval}>*/}
          {/*              <Radio value={1}>全时段售卖</Radio>*/}
          {/*              <Radio value={2}>自定义时间</Radio>*/}
          {/*            </RadioGroup>*/}
          {/*          </FormItem>*/}
          {/*          {*/}
          {/*            this.state.timeInterval == 2 ?*/}
          {/*              <div>*/}
          {/*                {*/}
          {/*                  listSaleTime.map((item, index) => {*/}
          {/*                    return (*/}
          {/*                      <div key={index.toString()}>*/}
          {/*                        <div className='input-specification'>*/}
          {/*                          <div style={{display: "row", width: "100vh"}}>*/}
          {/*                            <TimePicker*/}
          {/*                              defaultValue={moment('00:00', format)}*/}
          {/*                              format={format}/>*/}
          {/*                            <div style={{*/}
          {/*                              fontSize: "12px",*/}
          {/*                              marginLeft: "10px",*/}
          {/*                              marginRight: "10px"*/}
          {/*                            }}>至*/}
          {/*                            </div>*/}
          {/*                            <TimePicker*/}
          {/*                              defaultValue={moment('00:00', format)}*/}
          {/*                              format={format}/>*/}
          {/*                          </div>*/}
          {/*                          {index > 0 ?*/}
          {/*                            <div className='remove'*/}
          {/*                                 onClick={this.removeSaleTime.bind(this, index)}>*/}
          {/*                              <MinusCircleOutlined/>移除*/}
          {/*                            </div> : null*/}
          {/*                          }*/}
          {/*                        </div>*/}
          {/*                      </div>*/}
          {/*                    )*/}
          {/*                  })*/}
          {/*                }*/}
          {/*                {*/}
          {/*                  listSaleTime.length < 3 ?*/}
          {/*                    <a onClick={this.addSaleTime.bind(this)}>*/}
          {/*                      <PlusCircleOutlined/> 添加属性最多3个*/}
          {/*                    </a> : null*/}
          {/*                }*/}
          {/*              </div> : null*/}
          {/*          }*/}
          {/*        </div> : null*/}
          {/*    }*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="center" align="center">*/}
          {/*  <Col className={['gutter-row',]} offset={6} span={2}>*/}
          {/*    <div className='input-title-size'>其他信息</div>*/}
          {/*  </Col>*/}
          {/*  <Col className='gutter-row' span={12}>*/}
          {/*    <Form.Item label="参与热销排行">*/}
          {/*      <RadioGroup onChange={this.onChangeHot.bind(this)} value={this.state.isSaleHot}>*/}
          {/*        <Radio value={1}>是</Radio>*/}
          {/*        <Radio value={2}>否</Radio>*/}
          {/*      </RadioGroup>*/}
          {/*    </Form.Item>*/}
          {/*    <Form.Item label="单点时不配送">*/}
          {/*      <RadioGroup onChange={this.onChangeSingle.bind(this)} value={this.state.isSingle}>*/}
          {/*        <Radio value={1}>是</Radio>*/}
          {/*        <Radio value={2}>否</Radio>*/}
          {/*      </RadioGroup>*/}
          {/*    </Form.Item>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'middle'} justify={'center'}>
            <FormItem>
              <NavLink to={COMMON_ROUTER + '/goods'}><Button className="login-form-button" style={{marginRight: 30}}>返回</Button></NavLink>
            </FormItem>
            <FormItem>
              <Button type="primary" htmlType="submit" className="login-form-button">确认</Button>
            </FormItem>
          </Row>
        </Form>
      </Card>
    );
  }
}

const AddGoods = withRouter(AddGood)
export default AddGoods



// WEBPACK FOOTER //
// ./src/pages/goods/add-goods/index.js